import { merge } from 'lodash';
export function appendMetaHelpers(data, packageName) {
  var metaObject = _initializeMetaObject(packageName);
  metaObject.helpers = merge({}, metaObject.helpers, data);
}
export function appendMetaData(data, packageName) {
  var metaObject = _initializeMetaObject(packageName);
  metaObject.meta = merge({}, metaObject.meta, data);
}
export function appendMetaVersion(version, packageName) {
  if (!window._att_version) {
    window._att_version = {};
  }
  window._att_version[packageName] = version;
}
function _initializeMetaObject(name) {
  if (!window._att_dev) {
    window._att_dev = {};
  }
  if (!window._att_dev[name]) {
    window._att_dev[name] = {
      meta: {},
      helpers: {}
    };
  }
  return window._att_dev[name];
}